import React from "react";
import "./App.css";
import On from "./components/On";

function App() {
  return (
    <>
      <On />
    </>
  );
}

export default App;
